import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";

class AjaxSliderTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        panTo: PropTypes.func,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            current: 0,
            navposition: 0,
            urlDataMap: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false
            });
            self.loadAuthImages(response.data);
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    loadAuthImages(data) {
        if (!data.features) {
            return;
        }

        const cfg = this.props.tab.config;
        if (this.useAuth()) {
            data.features.forEach(item => {
                const url = FeatureUtils.prepareUrl(item, cfg.src);
                this.loadImageWithAuth(url, datasrc => {
                    this.setState(state => ({
                        urlDataMap: {
                            ...state.urlDataMap,
                            [url]: datasrc
                        }
                    }));
                });
            });
        } else {
            const urlDataMap = {};
            data.features.forEach(item => {
                const url = FeatureUtils.prepareUrl(item, cfg.src);
                urlDataMap[url] = url;
            });
            this.setState({urlDataMap});
        }
    }

    render() {
        return (
            <div className="feature-details-ajaxslider">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderSlider()}
                    </div>
                }
            </div>
        );
    }

    getCurrent() {
        return this.state.data.features[this.state.current];
    }

    getImageSrc(item) {
        const url = FeatureUtils.prepareUrl(item, this.props.tab.config.src);
        return this.state.urlDataMap[url] || null;
    }

    renderCurrentImage() {
        const item = this.getCurrent();
        if (item) {
            const src = this.getImageSrc(item);
            if (!src) {
                return null;
            }
            let image = (<img src={src}/>);
            if (this.props.tab.config.href) {
                const href = FeatureUtils.prepareUrl(item, this.props.tab.config.href);
                image = (<a href={href}>{image}</a>);
            }
            return (
                <div className="feature-details-ajaxslider-image">
                    <div className="image">
                        {image}
                    </div>
                    {this.renderCaption(item)}
                </div>
            );
        }
        return null;
    }

    renderSlider() {
        if (this.state.data.features) {
            const image = this.renderCurrentImage();
            const nav = this.renderThumbnails();
            return (
                <div>
                    {image}
                    {nav}
                </div>
            );
        }
        return null;
    }

    setCurrentImage(index) {
        index = index % this.state.data.features.length;
        this.setState({current: index});
    }

    setNavPosition(index) {
        if (index < 0) {
            index = this.state.data.features.length - 1;
        }
        if (index >= this.state.data.features.length - 1) {
            index = 0;
        }
        this.setState({navposition: index});
    }

    renderThumb(thumb) {
        const src = this.getImageSrc(thumb.item);
        if (!src) {
            return null;
        }
        return (
            <div className="nav-img" key={thumb.index}>
                <div className="image" onClick={() => this.setCurrentImage(thumb.index)}>
                    <img src={src}/>
                </div>
                {this.renderCaption(thumb.item)}
            </div>
        );
    }

    renderCaption(item) {
        const cfg = this.props.tab.config;
        let caption = null;
        if (cfg.caption) {
            const captionAttribute = cfg.caption;
            const captionContent = item.properties[captionAttribute];
            caption = (<div className="caption">{captionContent}</div>);
        }
        return caption;
    }

    renderThumbnails() {
        const total = this.state.data.features.length;
        const count = this.props.tab.config.thumbnails || 5;
        const showArrows = (total > count);
        const current = this.state.navposition;

        const thumbs = [];
        let navLeft = null;
        let navRight = null;
        if (showArrows) {
            navLeft = (
                <div className="nav-left" onClick={() => this.setNavPosition(this.state.navposition - 1)}>
                    <i className="icon icon-chevron-left"/>
                </div>
            );
            navRight = (
                <div className="nav-right" onClick={() => this.setNavPosition(this.state.navposition + 1)}>
                    <i className="icon icon-chevron-right"/>
                </div>
            );

            const list = [];
            list.push(...this.state.data.features);
            list.push(...this.state.data.features);
            for (let i = current; i < current + count; i++) {
                thumbs.push({
                    index: i,
                    item: list[i]
                });
            }
        } else {
            for (let i = 0; i < this.state.data.features.length; i++) {
                thumbs.push({
                    index: i,
                    item: this.state.data.features[i]
                });
            }
        }

        return (
            <div className="feature-details-ajaxslider-nav">
                {navLeft}
                <div className="nav-imgs">
                    {thumbs.map(t => this.renderThumb(t))}
                </div>
                {navRight}
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow
})(AjaxSliderTab);
